export const altar = {
  minor1: {
    // Your Kill Streak timer duration and reward bonus are doubled.
    row: 0,
    col: 4,
  },
  minor2: {
    // Pools of Reflection last for the entire Season and are not removed by death.
    row: 2,
    col: 2,
    requires: ['minor1'],
  },
  minor3: {
    // Items have no level requirement.
    row: 2,
    col: 6,
    requires: ['minor1'],
  },
  minor4: {
    // +200 Damage
    row: 3,
    col: 1,
    requires: ['minor2'],
  },
  minor5: {
    // +25% Missile Damage Reduction
    row: 3,
    col: 3,
    requires: ['minor2'],
  },
  minor6: {
    // +25% Movement Speed (Uncapped)
    row: 3,
    col: 5,
    requires: ['minor3'],
  },
  minor7: {
    // Increase damage against elites by 15%.
    row: 3,
    col: 7,
    requires: ['minor3'],
  },
  minor8: {
    // Picking up Health Globes grants a shield for 5% of your maximum health for 7 seconds. Max stacks 5.
    row: 4,
    col: 4,
    requires: ['minor4', 'minor5', 'minor6', 'minor7'],
  },
  minor9: {
    // +10% Damage
    row: 5,
    col: 1,
    requires: ['minor8'],
  },
  minor10: {
    // Double the amount of Death's Breaths that drop.
    row: 5,
    col: 4,
    requires: ['minor8'],
  },
  minor11: {
    // Critical hits grant resource.
    row: 5,
    col: 7,
    requires: ['minor8'],
  },
  minor12: {
    // Double the amount of Bounty Caches that drop from completing bounties.
    row: 6,
    col: 0,
    requires: ['minor9'],
  },
  minor13: {
    // Progress orbs from Nephalem and Greater Rifts are picked up automatically.
    row: 6,
    col: 2,
    requires: ['minor9'],
  },
  minor14: {
    // Reduces the damage taken from elites by 25%.
    row: 6,
    col: 3,
    requires: ['minor10'],
  },
  minor15: {
    // +25% Melee Damage Reduction.
    row: 6,
    col: 5,
    requires: ['minor10'],
  },
  minor16: {
    // Increases your highest elemental skill damage bonus by 10%.
    row: 6,
    col: 6,
    requires: ['minor11'],
  },
  minor17: {
    // Increase damage against elites by 20%.
    row: 6,
    col: 8,
    requires: ['minor11'],
  },
  minor18: {
    // Pets pick up Death's Breath.
    row: 7,
    col: 1,
    requires: ['minor12', 'minor13', 'minor19'],
  },
  minor19: {
    // Elite packs drop one additional progress orb.
    row: 7,
    col: 4,
    requires: ['minor14', 'minor15', 'minor18', 'minor20'],
  },
  minor20: {
    // Increase damage done to Bosses by 25%.
    row: 7,
    col: 7,
    requires: ['minor16', 'minor17', 'minor19'],
  },
  minor21: {
    // Pets pick up and salvage common, magic, and rare items.
    row: 8,
    col: 0,
    requires: ['minor18'],
  },
  minor22: {
    // Increase your chance to Dogde by 15%.
    row: 8,
    col: 2,
    requires: ['minor18'],
  },
  minor23: {
    // Double the chance to find a legendary item purchased from Kadala.
    row: 8,
    col: 3,
    requires: ['minor19'],
  },
  minor24: {
    // +15% Damage
    row: 8,
    col: 5,
    requires: ['minor19'],
  },
  minor25: {
    // Gain immunity to crowd-controlling effects.
    row: 8,
    col: 6,
    requires: ['minor20'],
  },
  minor26: {
    // Gain passability.
    row: 8,
    col: 8,
    requires: ['minor20'],
  },
  major1: {
    // When you drink your health potion, you manifest one of three runic circles on the ground that grant increased damage, increased cooldown reduction, or increased resource cost reduction.
    major: true,
    row: 9,
    col: 1,
    requires: ['minor21', 'minor22'],
  },
  major2: {
    // When you drink your health potion, all enemies within 25 yards deal 25% less damage.
    major: true,
    row: 9,
    col: 4,
    requires: ['minor23', 'minor24'],
  },
  major3: {
    // When you drink your health potion, gain a random shrine or pylon effect.
    major: true,
    row: 9,
    col: 7,
    requires: ['minor25', 'minor26'],
  },
  major4: {
    // When a primal item drops, a second random primal item drops as well.
    final: true,
    row: 10,
    col: 4,
  },
};
